import { CREATE_ORGANISATION } from "./action-types";

export function userCreateOrganisation(
  organisationId: string,
  organisationName: string
): any {
  return {
    type: CREATE_ORGANISATION,
    payload: {
      organisationId,
      organisationName,
    },
  };
}
